// extracted by mini-css-extract-plugin
export default {"title":"NoticePage_title__MH1SW","category":"NoticePage_category__gaDpv","date":"NoticePage_date__SQYxT","clip":"NoticePage_clip__Aj2xY"};